<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Campaign Highlight</p>
          <div>
            <el-tooltip content="Insert" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click.prevent="insert()"
              ></el-button>
            </el-tooltip>
            <Dialog />
          </div>
        </div>
        <Table />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from '../components/campaign-highlight/Table'
import Dialog from '../components/campaign-highlight/Dialog'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Table,
    Dialog
  },

  computed: {
    ...mapState('campaignHighlight', ['loading'])
  },

  methods: {
    ...mapMutations('campaignHighlight', ['setDialog', 'setSelectedCampaign']),
    initialCampaignHighlight() {
      return {
        id: null,
        type: 'artist'
      }
    },
    insert() {
      this.setDialog(true)
      this.setSelectedCampaign(this.initialCampaignHighlight())
    }
  }
}
</script>
